import { useMemo } from "react";
import { object, string } from "yup";

export type ContactServiceFormData = {
  codeService: string;
  message: string;
};

export type ContactServiceData = {
  codeService: string;
  message: string;
  locale: string;
  nomAffilie?: string;
  agence: string;
};


const useValidationSchemaContactService = () => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<ContactServiceFormData>().shape({
      codeService: string().required(requiredMessage),
      message: string().required(requiredMessage),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaContactService;
